module.exports = __webpack_public_path__ + "static/media/15f-08_Chapa-10-2015-Barra-de-grafito-6B-sobre-papel-90gr-1257x914mm.0cf17df6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15f/15f-08_Chapa-10-2015-Barra-de-grafito-6B-sobre-papel-90gr-1257x914mm.png
// module id = 181
// module chunks = 0